function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs, Circle, G, Use, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Circle, {
  id: "icon-pipette_svg__a",
  cx: 17.5,
  cy: 17.5,
  r: 17.5
}));

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Use, {
  fill: "#FFF",
  xlinkHref: "#icon-pipette_svg__a"
}), /*#__PURE__*/React.createElement(G, {
  fill: "#5B41F0",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M20.277 16.836a.558.558 0 010-.792l3.896-3.878a.614.614 0 01.042-.047c.425-.424.66-.986.66-1.584 0-.716-.66-1.414-1.38-1.414-.602 0-1.167.233-1.592.656a.497.497 0 01-.048.042l-3.895 3.877a.565.565 0 01-.795 0 .559.559 0 010-.793l3.94-3.921a.35.35 0 01.05-.045A3.362 3.362 0 0123.495 8C25.057 8 26 9.494 26 10.535c0 .875-.334 1.7-.942 2.328a.357.357 0 01-.045.05l-3.94 3.922a.563.563 0 01-.796.001z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M23.363 18a.717.717 0 01-.452-.154l-7.005-6.467a.464.464 0 010-.745.736.736 0 01.902 0l7.005 6.466c.25.205.25.54 0 .745a.71.71 0 01-.45.154z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M9.123 26a1.123 1.123 0 01-1.037-1.555l.364-2.327a5.058 5.058 0 011.113-1.696l8.253-8.257a.563.563 0 11.796.796L10.36 21.22c-.37.37-.67.826-.865 1.319l-.368 2.334 2.338-.544a4 4 0 001.324-.868l8.251-8.258a.563.563 0 11.796.797l-8.251 8.257a5.116 5.116 0 01-1.7 1.117l-2.334.541a1.1 1.1 0 01-.427.086z"
})));

function SvgIconPipette(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35
  }, props), _ref, _ref2);
}

export default SvgIconPipette;